import type { AuthState } from "@/data/types/auth";
import { createContext } from "react";

export interface AuthContextValue extends AuthState {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  handleCallback: () => Promise<void>;
  refreshTokens: () => Promise<boolean>;
  clearError: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
